// extracted by mini-css-extract-plugin
export var dividerContainer = "_7s-0";
export var line = "_7s-1";